export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero"
            className="relative min-h-[100vh] pt-24 overflow-hidden bg-[#FAF9F6]"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center min-h-[calc(100vh-6rem)]">
                {/* Left copy */}
                <div className="lg:col-span-5 relative z-10 reveal">
                <a
                    href="#top"
                    data-testid="logo-link"
                    className="flex items-baseline gap-2 mb-8"
                >
                    <span
                        className="font-serif-lux text-3xl md:text-4xl"
                        style={{ letterSpacing: "0.02em" }}
                    >
                        CM
                    </span>
                    <span className="tracking-luxe text-[#B89C6A]">RENOV</span>
                </a>
                <div className="flex items-center gap-3 mb-8">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">
                            Maison fondée en 2024 · Paris 7ème
                        </span>
                    </div>

                    <h1
                        className="font-serif-lux text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[0.98] text-[#1C1E1D]"
                        style={{ letterSpacing: "-0.015em" }}
                    >
                        Bâtir
                        <br />
                        <em className="italic text-[#B89C6A] font-normal">
                            haut de gamme
                        </em>
                        ,
                        <br />
                        <em className="italic font-normal">rénover</em>
                        <br />
                        avec noblesse.
                    </h1>

                    <p className="mt-8 max-w-md text-[15px] leading-relaxed text-[#1C1E1D]/75">
                        Maison spécialisée dans la <b>construction de maisons individuelles haut de gamme</b> — matériaux nouvelle génération, performance thermique, design contemporain — et la <b>rénovation haut de gamme</b> alliant matériaux nobles (bois, pierre) et applications innovantes.
                    </p>

                    <div className="mt-10 flex flex-wrap gap-4">
                        <a href="#devis" data-testid="hero-cta-quote" className="btn-champagne">
                            Estimer mon projet
                            <span aria-hidden>→</span>
                        </a>
                        <a
                            href="#realisations"
                            data-testid="hero-cta-portfolio"
                            className="btn-outline"
                        >
                            Voir les réalisations
                        </a>
                    </div>

                    <div className="mt-16 flex items-center gap-10">
                        <div>
                            <div className="font-serif-lux text-4xl text-[#1C1E1D]">
                                20<span className="text-[#B89C6A]">+</span>{" "}
                                <span className="text-2xl">ans</span>
                            </div>
                            <div className="tracking-luxe text-[#1C1E1D]/60 mt-1">
                                Expertise BTP
                            </div>
                        </div>
                        <div className="h-10 w-px bg-[#1C1E1D]/15" />
                        <div>
                            <div className="font-serif-lux text-4xl text-[#1C1E1D]">
                                Paris <span className="text-[#B89C6A]">7</span>
                                <sup className="text-[#B89C6A]">ème</sup>
                            </div>
                            <div className="tracking-luxe text-[#1C1E1D]/60 mt-1">
                                Studio &amp; siège
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right image */}
                <div className="lg:col-span-7 relative">
                    <div className="relative aspect-[4/5] lg:aspect-[5/6] overflow-hidden">
                        <img
                            src="https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/0qvm7kgm_IMG-20260819-WA0030.jpg"
                            alt="Chantier CM RENOV — construction maison individuelle"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#1C1E1D]/25" />
                    </div>

                    {/* Floating credential card */}
                    <div className="hidden md:block absolute -bottom-8 -left-8 lux-card p-6 max-w-xs">
                        <div className="tracking-luxe text-[#B89C6A]">
                            L'expertise · nouvelle Maison
                        </div>
                        <p className="font-serif-lux text-2xl mt-2 leading-tight">
                            Plus de 20 ans dans le BTP, portés par une nouvelle maison.
                        </p>
                        <p className="mt-3 text-[13px] text-[#1C1E1D]/70">
                            Notre fondateur — ancien cadre d'un grand groupe du bâtiment — apporte la rigueur d'un grand chantier à l'exigence d'un artisan.
                        </p>
                    </div>
                </div>
            </div>

            {/* Marquee-like bottom band */}
            <div className="border-y hairline mt-16">
                <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-6 flex flex-wrap items-center justify-between gap-6">
                    {[
                        "Rénovation complète",
                        "Construction maison individuelle",
                        "Design d'intérieur",
                        "Direction de chantier",
                        "Livraison clés en main",
                    ].map((t) => (
                        <span
                            key={t}
                            className="tracking-luxe text-[#1C1E1D]/70"
                        >
                            {t}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
